/**
 * Contact form options — mirror of backend/nwd-backend/config/contactOptions.js.
 *
 * The backend is authoritative: it validates the submitted enquiry key against
 * its own copy and looks the email subject line up from it, so a drift here
 * shows up as a rejected submission rather than as a malformed email.
 *
 * Field limits mirror the server's Joi schema. They are enforced server-side
 * regardless; the maxLength attributes just stop a user typing past the limit
 * and only finding out after they hit send.
 */

export const CONTACT_ENQUIRY_OPTIONS = [
  { value: "bug_found", label: "Report a Bug" },
  { value: "question", label: "Ask a Question" },
  { value: "suggestion", label: "Recommend a New Feature" },
  { value: "volunteer", label: "Volunteer Your Skills" },
  { value: "complaint", label: "Leave a Complaint" },
  { value: "testimony", label: "NWDs Challenge Testimony" },
  { value: "data_access", label: "Data Access Request" },
  { value: "account_delete", label: "Account Deletion Request" },
  { value: "other", label: "Something Else" },
];

export const CONTACT_LIMITS = {
  NAME_MAX: 80,
  EMAIL_MAX: 254,
  BODY_MIN: 10,
  BODY_MAX: 5000,
};

/**
 * The honeypot field name. Must match HONEYPOT_FIELD in
 * backend/nwd-backend/middlewares/botCheck.js.
 */
export const HONEYPOT_FIELD = "website";
